module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'jkfumny6',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
